import React from "react";
import { Quote, Star } from "lucide-react";
import { testimonials } from "../mock";

export default function Testimonials() {
  return (
    <section className="section bg-[#FBF8F4]">
      <div className="container-y">
        <div className="text-center mb-14">
          <p className="font-sans-y text-[11px] tracking-[0.3em] uppercase text-[#C9A961] mb-3">
            Reviews
          </p>
          <h2 className="font-serif-y text-3xl md:text-5xl text-[#1a1a1a]">
            What They Say About YBERA
          </h2>
          <div className="gold-divider w-32 mx-auto mt-8" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white p-8 border border-[#EAE3D8] flex flex-col gap-4 hover:shadow-lg transition-shadow duration-300"
            >
              <Quote size={28} className="text-[#C9A961]" />
              <p className="font-sans-y text-[15px] leading-relaxed text-[#333]">{t.text}</p>
              <div className="mt-auto pt-4 border-t border-[#EAE3D8]">
                <div className="flex items-center gap-1 mb-2">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={12} fill="#C9A961" color="#C9A961" />
                  ))}
                </div>
                <p className="font-serif-y text-[16px] text-[#1a1a1a]">{t.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
